import { QueryClient } from '@tanstack/react-query';

/**
 * App-wide query client. Lives outside the React tree so non-React code
 * (e.g. deeplink handlers) can prefetch into the same cache the hooks read.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
});
